import {
  GET_MACHINE_CLEANING_AREA_FAIL,
  GET_MACHINE_CLEANING_AREA_LIST_SUCCESS,
  GET_MACHINE_CLEANING_AREA_REQUEST,
  GET_MACHINE_CLEANING_AREA_TOTAL_BY_TIME_SUCCESS,
  GET_MACHINE_CLEANING_AREA_TOTAL_BY_ALL_SUCCESS,
  GET_MACHINE_CLEANING_AREA_TOTAL_BY_TIME_FAIL,
  GET_MACHINE_CLEANING_AREA_TOTAL_BY_TIME_REQUEST,
  GET_MACHINE_CLEANING_AREA_TOTAL_BY_ALL_FAIL,
  GET_MACHINE_CLEANING_AREA_TOTAL_BY_ALL_REQUEST
} from './action';
import * as queries from './queries';

export function fetchMachineCleaningAreaYear(payload) {
  const { machineId } = payload;
  return async (dispatch, _, { client } = {}) => {
    try {
      dispatch({ type: GET_MACHINE_CLEANING_AREA_REQUEST });
      const clientResponse = await client.query({
        query: queries.getYearCleaningReportStatistics,
        variables: {
          machineId
        }
      });

      const list = clientResponse?.data?.getYearCleaningReportStatistics;

      dispatch({
        type: GET_MACHINE_CLEANING_AREA_LIST_SUCCESS,
        payload: {
          list
        }
      });
    } catch (error) {
      dispatch({
        type: GET_MACHINE_CLEANING_AREA_FAIL,
        payload: { error }
      });
    }
  };
}

export function fetchMachineCleaningAreaPast6Months(payload) {
  const { machineId } = payload;
  return async (dispatch, _, { client } = {}) => {
    try {
      dispatch({ type: GET_MACHINE_CLEANING_AREA_REQUEST });
      const clientResponse = await client.query({
        query: queries.getPast6MonthsCleaningReportStatistics,
        variables: {
          machineId
        }
      });

      const list = clientResponse?.data?.getPast6MonthsCleaningReportStatistics;

      dispatch({
        type: GET_MACHINE_CLEANING_AREA_LIST_SUCCESS,
        payload: {
          list
        }
      });
    } catch (error) {
      dispatch({
        type: GET_MACHINE_CLEANING_AREA_FAIL,
        payload: { error }
      });
    }
  };
}

export function fetchMachineCleaningAreaMonth(payload) {
  const { machineId } = payload;
  return async (dispatch, _, { client } = {}) => {
    try {
      dispatch({ type: GET_MACHINE_CLEANING_AREA_REQUEST });
      const clientResponse = await client.query({
        query: queries.getMonthCleaningReportStatistics,
        variables: {
          machineId
        }
      });

      const list = clientResponse?.data?.getMonthCleaningReportStatistics;

      dispatch({
        type: GET_MACHINE_CLEANING_AREA_LIST_SUCCESS,
        payload: {
          list
        }
      });
    } catch (error) {
      dispatch({
        type: GET_MACHINE_CLEANING_AREA_FAIL,
        payload: { error }
      });
    }
  };
}

export function fetchMachineCleaningAreaWeek(payload) {
  const { machineId } = payload;
  return async (dispatch, _, { client } = {}) => {
    try {
      dispatch({ type: GET_MACHINE_CLEANING_AREA_REQUEST });
      const clientResponse = await client.query({
        query: queries.getWeekCleaningReportStatistics,
        variables: {
          machineId
        }
      });

      const list = clientResponse?.data?.getWeekCleaningReportStatistics;

      dispatch({
        type: GET_MACHINE_CLEANING_AREA_LIST_SUCCESS,
        payload: {
          list
        }
      });
    } catch (error) {
      dispatch({
        type: GET_MACHINE_CLEANING_AREA_FAIL,
        payload: { error }
      });
    }
  };
}

export function fetchMachineCleaningAreaTotalByAll(payload) {
  const { machineId } = payload;
  return async (dispatch, _, { client } = {}) => {
    try {
      dispatch({ type: GET_MACHINE_CLEANING_AREA_TOTAL_BY_ALL_REQUEST });
      const clientResponse = await client.query({
        query: queries.getTotalCleaningReportStatistics,
        variables: {
          machineId
        }
      });

      const total = clientResponse?.data?.getTotalCleaningReportStatistics;

      dispatch({
        type: GET_MACHINE_CLEANING_AREA_TOTAL_BY_ALL_SUCCESS,
        payload: {
          total
        }
      });
    } catch (error) {
      dispatch({
        type: GET_MACHINE_CLEANING_AREA_TOTAL_BY_ALL_FAIL,
        payload: { error }
      });
    }
  };
}

export function fetchMachineCleaningAreaTotalByTime(payload) {
  const { machineId, groupBy } = payload;
  return async (dispatch, _, { client } = {}) => {
    try {
      dispatch({ type: GET_MACHINE_CLEANING_AREA_TOTAL_BY_TIME_REQUEST });
      const clientResponse = await client.query({
        query: queries.getTotalCleaningReportStatistics,
        variables: {
          machineId,
          groupBy
        }
      });

      const totalByTime =
        clientResponse?.data?.getTotalCleaningReportStatistics;

      dispatch({
        type: GET_MACHINE_CLEANING_AREA_TOTAL_BY_TIME_SUCCESS,
        payload: {
          totalByTime
        }
      });
    } catch (error) {
      dispatch({
        type: GET_MACHINE_CLEANING_AREA_TOTAL_BY_TIME_FAIL,
        payload: { error }
      });
    }
  };
}
